var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vias",
    xmlns: "http://www.w3.org/2000/svg",
    width: 235.781,
    height: 235.781,
    viewBox: "0 0 235.781 235.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #418c5a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-1",
    d: "M239.219,156a63.554,63.554,0,0,0-58.485,88.418H133.38V220.472a4.605,4.605,0,1,0-9.21,0v28.552a4.605,4.605,0,0,0,4.605,4.6H185.6a63.785,63.785,0,0,0,4.264,5.936c.074.106.147.212.23.313l39.691,50.854H208.195a4.605,4.605,0,0,0,0,9.21h62.192a4.605,4.605,0,0,0,0-9.21H248.65l39.917-51.158.046-.064A63.53,63.53,0,0,0,239.219,156Zm42.141,97.854-.166.212-41.976,53.788-41.547-53.23a4.785,4.785,0,0,0-.368-.511,54.34,54.34,0,1,1,84.057-.281Z",
    transform: "translate(-66.989 -84.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-1",
    d: "M365.732,240.148a4.605,4.605,0,0,0-8.75,2.823,28.552,28.552,0,1,1-19.475-18.724,4.606,4.606,0,0,0,2.455-8.879,37.762,37.762,0,1,0,25.788,24.776Z",
    transform: "translate(-157.559 -115.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-1",
    d: "M422.823,236.466l-.033-.046a4.6,4.6,0,1,0-6.512,6.512l.042.041a4.6,4.6,0,1,0,6.512-6.512Z",
    transform: "translate(-223.851 -126.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-1",
    d: "M107.911,420H4.605a4.605,4.605,0,0,0,0,9.21h98.7v28.551a4.605,4.605,0,1,0,9.21,0V424.605A4.6,4.6,0,0,0,107.911,420Z",
    transform: "translate(0 -226.586)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-1",
    d: "M84.034,0a4.605,4.605,0,0,0-4.605,4.605V37.762H4.605a4.605,4.605,0,0,0,0,9.21H84.034a4.605,4.605,0,0,0,4.605-4.605V4.605A4.605,4.605,0,0,0,84.034,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-1",
    d: "M40.535,154H5.605a4.605,4.605,0,1,0,0,9.21H35.93v80.129H5.605a4.605,4.605,0,1,0,0,9.21h34.93a4.6,4.6,0,0,0,4.605-4.6V158.605A4.605,4.605,0,0,0,40.535,154Z",
    transform: "translate(-0.539 -83.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-1",
    d: "M132.03,252.35a4.6,4.6,0,1,0,1.349,3.256A4.6,4.6,0,0,0,132.03,252.35Z",
    transform: "translate(-66.988 -135.413)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-1",
    d: "M184.879,154h-56.1a4.605,4.605,0,0,0-4.605,4.605v25.558a4.605,4.605,0,1,0,9.21,0V163.21h51.5a4.605,4.605,0,1,0,0-9.21Z",
    transform: "translate(-66.989 -83.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-1",
    d: "M303.323,0a4.605,4.605,0,0,0-4.605,4.605V37.762H230.01V4.605a4.605,4.605,0,0,0-9.21,0V42.367a4.6,4.6,0,0,0,4.605,4.605h77.918a4.605,4.605,0,0,0,4.605-4.605V4.605A4.605,4.605,0,0,0,303.323,0Z",
    transform: "translate(-119.12 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-1",
    d: "M467.473,37.762H447.21V4.605a4.605,4.605,0,0,0-9.21,0V42.367a4.606,4.606,0,0,0,4.606,4.605h24.867a4.605,4.605,0,0,0,0-9.21Z",
    transform: "translate(-236.297 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-1",
    d: "M479.569,154H465.025a4.605,4.605,0,0,0,0,9.21h14.544a4.605,4.605,0,0,0,0-9.21Z",
    transform: "translate(-248.392 -83.081)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVias);
export default __webpack_public_path__ + "static/media/Vias.06549bc2d1bae4e24ef5b50680ba31ad.svg";
export { ForwardRef as ReactComponent };